import React from 'react';
import { useAppSelector } from '~redux/hooks';
import GoldInventoryExportPDF from './ExportPDF';

const BranchInventoryPDF = () => {
    const serialNumberListing = useAppSelector((state) => state.gold.serialNumber.serialNumberListing.data);
    const branchInventoryListing = useAppSelector((state) => state.gold.goldInventoryReport.branchInventory.data);

    return (
        <div>
            <GoldInventoryExportPDF
                serialNumberListing={serialNumberListing}
                branchInventoryListing={branchInventoryListing}
            />
        </div>
    );
};

export default BranchInventoryPDF;
